<template>
  <div class="content">
    <div class="md-layout">
     
        <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="orange">
            <h4 class="title">Drafts</h4>
            <p class="category">These still need some work!</p>
          </md-card-header>
          <md-card-content>
           <div>
              <md-table v-model="drafts">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Question">{{ item.question }}</md-table-cell>
                    <md-table-cell md-label="Tags"><md-button class="md-info md-round md-xsmall" v-for="tag in item.tagpaths" v-bind:key="tag">
                          {{tag}}
                        </md-button>
                    </md-table-cell>
                  <md-table-cell md-label="Created">{{ item.datecreatedlbl }}</md-table-cell>
                         <md-table-cell>
                    <router-link :to="{ name: 'Update Memry', params: { id: item.id } }">
                        <i class="md-icon md-icon-font md-theme-default" style="float:right;cursor:pointer;">edit</i>
                    </router-link>
                   </md-table-cell>
                </md-table-row>
              </md-table>
            </div>
          </md-card-content>
        </md-card>
      </div>
   
    </div>
    
  </div>

</template>

<script>
import { SimpleTable } from "@/components";
import ApiService from "@/services/api.service";
import UtilService from "@/services/util.service";

export default {
  components: {
     SimpleTable
  },
  data() {
    return {
      memries: [],
      drafts: [],
      tags: [],
      memry: {},
      overduecount: 0,
      todaycount: 0,
      errorString: null,
      showAnswer: false,
      showHint: false,
      
    };
  },
  mounted() {
       

      ApiService.getTags()
        .then(response => { 
           
           
            if(!response || response.data == null) {
              this.tags = [];
            } else {
              this.tags = response.data;
               console.log("Fetching Tags", response.data);
            }

             ApiService.getDrafts()
             .then(response => {
                 if(!response || response.data == null) {
                    this.memries = [];
                  } else {
                    var listmemries = response.data;
                    var memryResp = UtilService.extendMemries(listmemries,this.tags);
                    this.drafts = memryResp.drafts;
                  }

             })

        });
  },
  methods: {
  }
};
</script>
